import React from 'react';
import { SlideDef } from './slides';
import { Cover, Intro, Merci, Plan, Sources, Verdict } from './SlidesNeutral';
import { AppPart, Axis1Open, Axis2Open, Piece } from './SlidesApp';

export function SlideRenderer({ d }: { d: SlideDef }) {
  switch (d.kind) {
    case 'cover': return <Cover d={d} />;
    case 'intro': return <Intro d={d} />;
    case 'plan': return <Plan d={d} />;
    case 'axis1': return <Axis1Open d={d} />;
    case 'app': return <AppPart d={d} />;
    case 'axis2': return <Axis2Open d={d} />;
    case 'piece': return <Piece d={d} />;
    case 'verdict': return <Verdict d={d} />;
    case 'sources': return <Sources d={d} />;
    default: return <Merci />;
  }
}
